"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThreeDots = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ThreeDots = function ThreeDots(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      width: props.width,
      height: props.height,
      viewBox: "0 0 120 30",
      xmlns: "http://www.w3.org/2000/svg",
      fill: props.color,
      "aria-label": props.label
    },
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "15",
      cy: "15",
      r: props.radius + 6
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "r",
      from: "15",
      to: "15",
      begin: "0s",
      dur: "0.8s",
      values: "15;9;15",
      calcMode: "linear",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fillOpacity",
      from: "1",
      to: "1",
      begin: "0s",
      dur: "0.8s",
      values: "1;.5;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "60",
      cy: "15",
      r: props.radius,
      attributeName: "fillOpacity",
      from: "1",
      to: "0.3"
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "r",
      from: "9",
      to: "9",
      begin: "0s",
      dur: "0.8s",
      values: "9;15;9",
      calcMode: "linear",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fillOpacity",
      from: "0.5",
      to: "0.5",
      begin: "0s",
      dur: "0.8s",
      values: ".5;1;.5",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "105",
      cy: "15",
      r: props.radius + 6
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "r",
      from: "15",
      to: "15",
      begin: "0s",
      dur: "0.8s",
      values: "15;9;15",
      calcMode: "linear",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fillOpacity",
      from: "1",
      to: "1",
      begin: "0s",
      dur: "0.8s",
      values: "1;.5;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })))
  );
};

exports.ThreeDots = ThreeDots;
ThreeDots.propTypes = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  label: _propTypes["default"].string,
  radius: _propTypes["default"].number
};
ThreeDots.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading",
  radius: 9
};